import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
let NgxSpinnerComponent = /*#__PURE__*/(() => {
  class NgxSpinnerComponent {
    constructor() {
      this.size = 'md';
      this.color = 'primary';
    }
    static {
      this.ɵfac = function NgxSpinnerComponent_Factory(t) {
        return new (t || NgxSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxSpinnerComponent,
        selectors: [["ngx-spinner"]],
        inputs: {
          size: "size",
          color: "color"
        },
        decls: 1,
        vars: 4,
        template: function NgxSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div");
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate2("spinner ", ctx.size, " ", ctx.color, "");
          }
        },
        styles: [".spinner[_ngcontent-%COMP%]{height:var(--spinner-size);width:var(--spinner-size);border-radius:50%;background:radial-gradient(farthest-side,var(--spinner-color) 60%,rgba(0,0,0,0)) top/var(--stroke-width) var(--stroke-width) no-repeat,conic-gradient(rgba(0,0,0,0) 0%,var(--spinner-color));-webkit-mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - var(--stroke-width)),#000 30%);animation:_ngcontent-%COMP%_spinner-ratate-anim .9s infinite linear 1ms}.spinner.primary[_ngcontent-%COMP%]{--spinner-color: #0040ff}.spinner.black[_ngcontent-%COMP%]{--spinner-color: #2c3544}.spinner.white[_ngcontent-%COMP%]{--spinner-color: #ffffff}.spinner.sm[_ngcontent-%COMP%]{--spinner-size: 16px;--stroke-width: 3px}.spinner.md[_ngcontent-%COMP%]{--spinner-size: 20px;--stroke-width: 4px}.spinner.lg[_ngcontent-%COMP%]{--spinner-size: 24px;--stroke-width: 4px}.spinner.xl[_ngcontent-%COMP%]{--spinner-size: 32px;--stroke-width: 4px}@keyframes _ngcontent-%COMP%_spinner-ratate-anim{25%{transform:rotate(90deg)}75%{transform:rotate(300deg)}to{transform:rotate(360deg)}}"]
      });
    }
  }
  return NgxSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxSpinnerModule = /*#__PURE__*/(() => {
  class NgxSpinnerModule {
    static {
      this.ɵfac = function NgxSpinnerModule_Factory(t) {
        return new (t || NgxSpinnerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxSpinnerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return NgxSpinnerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-spinner
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSpinnerComponent, NgxSpinnerModule };
